var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.33386H6L8.19333 5.14053C8.25582 5.07855 8.30541 5.00482 8.33926 4.92358C8.37311 4.84234 8.39053 4.7552 8.39053 4.66719C8.39053 4.57919 8.37311 4.49205 8.33926 4.41081C8.30541 4.32957 8.25582 4.25584 8.19333 4.19386C8.06842 4.06969 7.89946 4 7.72333 4C7.54721 4 7.37824 4.06969 7.25333 4.19386L4.39333 7.06052C4.14294 7.30942 4.00149 7.64747 4 8.00052C4.00324 8.35126 4.14456 8.68659 4.39333 8.93386L7.25333 11.8005C7.31549 11.8622 7.3892 11.9111 7.47025 11.9443C7.55129 11.9776 7.63809 11.9945 7.72569 11.9942C7.81329 11.9939 7.89996 11.9764 7.98077 11.9425C8.06159 11.9087 8.13495 11.8593 8.19667 11.7972C8.25839 11.735 8.30726 11.6613 8.3405 11.5803C8.37373 11.4992 8.39068 11.4124 8.39037 11.3248C8.39006 11.2372 8.3725 11.1506 8.33869 11.0697C8.30489 10.9889 8.25549 10.9156 8.19333 10.8539L6 8.66719H12.6667C12.8435 8.66719 13.013 8.59695 13.1381 8.47193C13.2631 8.3469 13.3333 8.17733 13.3333 8.00052C13.3333 7.82371 13.2631 7.65414 13.1381 7.52912C13.013 7.4041 12.8435 7.33386 12.6667 7.33386Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.032f33094bde08dc64d368cafeb0accd.svg";
export { ForwardRef as ReactComponent };